import { FormikProps } from 'formik';
import { Dispatch, memo, SetStateAction, SyntheticEvent, useCallback, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { RoundButton } from '../../Button/RoundButton/RoundButton';
import { ConfigurationsPageFormValues } from '../../pages/ConfigurationPage';
import { ResourcesPageFormValues } from '../../pages/ResourcesPage';
import { Footer, RightComponentFooter } from './FormPageFooter.style';

export const FormPageFooter = memo(function FormPageFooter({
    isLoading,
    setEnableRefetch,
    ...props
}: {
    isLoading: boolean;
    setEnableRefetch: Dispatch<SetStateAction<boolean>>;
} & FormikProps<ResourcesPageFormValues | ConfigurationsPageFormValues>) {
    const handleButtonReset = useCallback(
        (e: SyntheticEvent<any, Event>) => {
            props.handleReset(e);
            setEnableRefetch(true);
        },
        [props, setEnableRefetch],
    );

    useEffect(() => {
        if (props.dirty) {
            setEnableRefetch(false);
        } else {
            setEnableRefetch(true);
        }
    }, [props.dirty, setEnableRefetch]);

    return (
        <Footer>
            <RightComponentFooter>
                <RoundButton
                    color="primary"
                    size="medium"
                    variant="outlined"
                    sx={{ marginRight: '80px' }}
                    disabled={!props.dirty}
                    onClick={handleButtonReset}
                >
                    <FormattedMessage id={'form.button.cancel'} />
                </RoundButton>
                <RoundButton
                    color="primary"
                    size="medium"
                    variant="contained"
                    disabled={!props.isValid || !props.dirty || isLoading}
                    loading={isLoading}
                    type="submit"
                >
                    <FormattedMessage id={'form.button.confirm'} />
                </RoundButton>
            </RightComponentFooter>
        </Footer>
    );
});
